import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';

import { ConfigService } from './getSettings';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;
    protected appSettings = ConfigService.settings;

    constructor(private http: HttpClient) {
    }

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Performs the auth
     * @param username username of user
     * @param password password of user
     */
    login(username: string, password: string) {
        return this.http.post<any>(`${this.appSettings.apiSettings.apiUrl}${this.appSettings.apiPath.users}/api/auth/login`, { username, password })
            .pipe(
                map(user => {
                    // store user details and jwt token in session storage to keep user logged in between page refreshes
                    sessionStorage.setItem('username', user["username"]);
                    sessionStorage.setItem('userAvatar', "assets/images/users/avatar-6.jpg");
                    sessionStorage.setItem('tokenInfo', user["token"]);
                    sessionStorage.setItem('roleAccess', user["roleAccess"]);
                    return user;
                }));
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend().forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

    /**
     * Logout the user
     */
    logout() {
        sessionStorage.removeItem('tokenInfo');
        sessionStorage.removeItem('roleAccess');
        sessionStorage.removeItem('userAvatar');
        sessionStorage.removeItem('username');
    }
}

